export default __webpack_public_path__ + "static/media/linkedin-login.033d5174.svg";